import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { copyText, DisplayToast } from '@/helpers';

const COPIED_RESET_MS = 2000;

export const useCopyText = () => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (!isCopied) {
      return;
    }
    const timeout = setTimeout(() => setIsCopied(false), COPIED_RESET_MS);
    return () => clearTimeout(timeout);
  }, [isCopied]);

  const copy = async (value: string) => {
    const isSuccess = await copyText(value);
    setIsCopied(isSuccess);
    if (!isSuccess) {
      DisplayToast.error(t('Failed to copy'));
    }
    return isSuccess;
  };

  return { isCopied, copy };
};
